import React from "react";
import Text, { type Variant as TextVariant } from "./Text";
import { IconType } from "react-icons";
import Icon from "./Icon";
import { BUTTON_BASE_CLASSES, getButtonStateClasses } from "./buttonStyles";

type BaseButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  isSelected?: boolean;
  textVariant?: TextVariant;
  icon?: IconType;
};

const BaseButton: React.FC<BaseButtonProps> = ({
  children,
  className,
  isSelected = false,
  textVariant = "body/m",
  icon,
  ...rest
}) => {
  const baseClasses = `inline-flex justify-center items-center px-4 py-2 min-h-[44px] gap-2 ${BUTTON_BASE_CLASSES}`;
  const isDisabled = !!(rest as React.ButtonHTMLAttributes<HTMLButtonElement>).disabled;
  const stateClasses = getButtonStateClasses(isSelected, isDisabled);

  return (
    <button className={`${baseClasses} ${stateClasses} ${className}`} {...rest}>
      {icon && <Icon icon={icon} size={24} className="flex-shrink-0" />}

      <Text variant={textVariant} weight="bold" as="span">
        {children}
      </Text>
    </button>
  );
};

export default BaseButton;
